import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FloatLabelType } from '@angular/material/form-field';
import { debounceTime, distinctUntilChanged, map, startWith } from 'rxjs/operators';

@Component({
  selector: 'common-input-outline',
  templateUrl: './input-outline.component.html',
  styleUrls: ['./input-outline.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InputOutlineComponent implements OnInit, OnChanges {
  @ViewChild('inputRef') inputRef!: ElementRef<HTMLInputElement>;

  searchControl = new FormControl('');

  @Input() label?: string;
  @Input() placeholder: string = 'Label';
  @Input() disabled: boolean = false;
  @Input() type: string = 'text';
  @Input() floatLabelType: FloatLabelType = 'never';
  @Input() debounceTime: number = 0;
  @Input() valueDefault?: string ///probar los formControl;

  @Input() maxCaracterLength?: number;
  @Input() minCaracterLength?: number;

  @Input() customIconLeft?: string;
  @Input() customIconRight?: string;

  @Output() outputSearch: EventEmitter<string> = new EventEmitter();
  @Output() outputClear: EventEmitter<boolean> = new EventEmitter();


  constructor() {
    this.observerChangeSearchForm()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['valueDefault']) {
      this.searchControl.setValue(changes['valueDefault'].currentValue, { emitEvent: false });
    }
    if (changes['disabled']) {
      this._syncDisabledState();
    }
  }

  ngOnInit(): void {
    if (this.valueDefault) {
      this.searchControl.setValue(this.valueDefault, { emitEvent: false });
    }
    this._syncDisabledState();
  }

  private _syncDisabledState(): void {
    if (this.disabled) {
      if (this.searchControl.enabled) {
        this.searchControl.disable({ emitEvent: false });
      }
    } else if (this.searchControl.disabled) {
      this.searchControl.enable({ emitEvent: false });
    }
  }

  onClear(): void {
    this.outputClear.emit(null);
    this.searchControl.reset('', { emitEvent: false });
    this.blurInput();
  }

  blurInput(): void {
    this.inputRef.nativeElement.blur();
  }

  observerChangeSearchForm() {
    this.searchControl.valueChanges
      .pipe(
        debounceTime(this.debounceTime), // Espera el tiempo configurado antes de emitir
        distinctUntilChanged() // Emite solo si el valor cambia
      )
      .subscribe((value: string | null) => {
        if (value) this.outputSearch.emit(this.searchControl.value);
      });
  }
}
